import { Button, Select } from "antd";
import React, { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useUnitContext from "../../../hooks/useUnitContext";
import { ContainerSelectUnit, CustomSelect } from "./styles";

function SelectUnit({
  customSelect = false,
  placeholder = null,
  value,
  onDeselect,
  onChange,
  disabled = false,
  allowClear = true,
  showSearch = true,
}) {
  const { translation } = useSelector((state) => state.app);
  const { dataList, isLoadingDataList, fetchData, openDrawer, lastSavedUnit } =
    useUnitContext();

  const awaitingCreate = useRef(false);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (awaitingCreate.current && lastSavedUnit?.id) {
      onChange(lastSavedUnit.id);
      awaitingCreate.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSavedUnit]);

  const createNewUnit = useCallback(() => {
    awaitingCreate.current = true;
    openDrawer();
  }, [openDrawer]);

  const activeUnits = dataList.filter((unit) => unit.status === "Active");

  const options = activeUnits.map((unit) => (
    <Select.Option key={unit.id} value={unit.id}>
      {`${unit.name}${unit.description ? ` - ${unit.description}` : ""}`}
    </Select.Option>
  ));

  const hasMatchingOption = activeUnits.some((unit) => unit.id === value);

  const selectProps = {
    loading: isLoadingDataList,
    value: hasMatchingOption ? value : undefined,
    placeholder: placeholder
      ? placeholder
      : translation.defaultSelectPlaceholder,
    showSearch,
    optionFilterProp: "children",
    filterOption: (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    allowClear,
    disabled,
    onDeselect,
    onChange,
  };

  const SelectElement = customSelect ? (
    <CustomSelect {...selectProps}>{options}</CustomSelect>
  ) : (
    <Select {...selectProps}>{options}</Select>
  );

  return (
    <ContainerSelectUnit>
      {SelectElement}
      <Button
        shape="circle"
        icon="plus"
        disabled={disabled}
        onClick={createNewUnit}
      />
    </ContainerSelectUnit>
  );
}

export default SelectUnit;
